<template>
    <div class="content">
        <div class="head">
            <div>
                <p class="title">作业详情</p>
                <p @click="back()"
                   class="back"></p>
                <p class="preview"
                   @click="preview(type)">作业预览</p>
            </div>
        </div>
        <div class="time_box"
             v-if="!is_active">
            <p class="jzTime">截止时间：{{ endDate }}</p>
            <p class="endTime"
               v-if="flagBoon">已截止</p>
        </div>
        <div :class="['tabs_tit',{'tabs_tit-top':is_active}]">
            <div class="notab">
                完成情况
            </div>
        </div>
        <template v-if="loading">
            <div class="left">
                <div class="left_box">
                    <div class="box_bg1">
                        <div>
                            <p>{{finish}}人</p>
                            <p>已完成</p>
                        </div>
                        <div>
                            <p>{{unfinish}}人</p>
                            <p>未完成</p>
                            <p @click="cuicu">催促</p>
                        </div>
                    </div>
                </div>
                <div class="list">
                    <div class="list_box">
                        <div class="list_title">
                            <p>学生情况</p>
                            <!-- <p @click="news">写评语</p> -->
                        </div>
                    </div>
                    <div class="lists">
                        <div>
                            <p class="name">姓名</p>
                            <p class="score">成绩</p>
                            <p class="upTime">提交时间</p>
                        </div>
                    </div>
                    <div class="lists1">
                        <div class="lists_box"
                             v-if="finishlist.length"
                             v-for="(i,index) in finishlist">
                            <div class="lists1_result"
                                 v-if="i.status != '0'">
                                <p><i>{{i.real_name}}<span class="tig-bu"
                                              v-if="i.status == '2'&&!is_active">补</span></i></p>
                                <p><i>{{i.all_time | trans}}</i></p>
                                <p class="no">{{i.done_time|dateFormat('MM月DD日 hh:mm')}}<span :class="[i.openFlag?'colse':'open']"
                                          @click="open(i,index)"></span></p>
                            </div>
                            <div class="lists1_result"
                                 v-else>
                                <p>{{i.real_name}}</p>
                                <p>未完成</p>
                                <p class="no">--</p>
                            </div>
                            <div class="lists1_detail"
                                 v-show="i.openFlag">
                                <ul v-if="Object.keys(i.all_task).length != 0 ">
                                    <li v-if='i.all_task.paragraph'>
                                        <p class="detail_tit">标自然段</p>
                                        <p>{{i.all_task.paragraph | trans}}</p>
                                    </li>
                                    <li v-if='i.all_task.text||i.all_task.text===0'>
                                        <p class="detail_tit">课文跟读</p>
                                        <p><em class="result"
                                                v-if="i.result_text">{{i.result_text}}</em><span :class="[audio&&i.openAudio?'playicon':'stopicon']"
                                                  @click="play(i)"></span>{{i.all_task.text | trans}}</p>
                                    </li>
                                    <li v-if='i.all_task.words'>
                                        <p class="detail_tit">学写字</p>
                                        <p>{{i.all_task.words | trans}}</p>
                                    </li>
                                    <li v-if="i.all_task.hasOwnProperty('qn_video')">
                                        <p class="detail_tit">视频导学</p>
                                        <p>完成</p>
                                    </li>
                                    <li v-if="i.all_task.hasOwnProperty('qn_text')">
                                        <p class="detail_tit">课文梳理</p>
                                        <p>完成</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div :class='["bottom_btn",flagBoon&finish>0?"bottom_btn1":"bottom_btn2"]'
                 v-if="!is_active">
                <div class='bottom_btn-box'>
                    <div class="bottom_btn-div reward"
                         @click="reward"
                         v-if="flagBoon&finish>0">
                        <p><img src="./img/test_jp.png">奖励和评语</p>
                    </div>
                    <div class="bottom_btn-div share"
                         @click="reportClick">
                        <p><img src="./img/test_fx.png">分享报告给家长</p>
                    </div>
                </div>
            </div>

            <div class="bottom_btn"
                 v-if="is_active">
                <div class="hdshare bottom_btn-box share"
                     @click="HDshare">
                    <p>分享学生完成情况</p>
                </div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <div id="layui-m-layer"
             class="layui-m-layer layui-m-layer0"
             v-if='urge'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <div class="title_container">
                            <span @click="send_qun"
                                  :class="{'title_on':send_Type=='qun'}"
                                  class="lay_title lay_title1">发到家长群</span>
                            <span @click="send_msg"
                                  :class="{'title_on':send_Type=='msg'}"
                                  class="lay_title lay_title2"
                                  v-if="platform_id=='410000' && !is_active">发送短信<span class="title_tip">（仅发送开通用户）</span></span>
                        </div>
                        <textarea v-if="is_active"
                                  readonly="readonly"
                                  class="textar"
                                  v-bind:maxlength="200"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <textarea v-else
                                  class="textar"
                                  v-bind:maxlength="200"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'
                                  v-if="send_Type=='qun'">发到家长群里</span>
                            <span @click='release2'
                                  v-if="send_Type=='msg'">发送短信</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="layui-m-layer1"
             class="layui-m-layer layui-m-layer0"
             v-if='hd_layer'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <p style='text-align:left;padding:0.75rem 0.75rem 0.4rem;font-size:0.75rem;color:#333;'>发到家长群</p>
                        <textarea class="textar"
                                  v-bind:maxlength="200"
                                  ref="textar"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'>发到家长群</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <audio :src="audio" v-if="audio" @ended="audioEnded" ref="mp3"></audio>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'COMPONENTS/base/tealoading.vue';
import headers from 'COMPONENTS/base/header.vue'

export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            send_Type: 'qun',
            sid: 51,
            taskId: this.$route.params.taskid, //作业id
            classId: this.$route.params.classid, //班级id
            taskType: this.$route.params.taskType,//作业类型1课前2课后3课外
            testType: this.$route.params.testType,
            type: this.$route.params.type,//1:课文预习 2同步习题 3单元复习 4高频错题 5生词听写 6 课外阅读
            task_name: this.$route.query.task_name,
            begin_date: this.$route.query.begin_date,
            mid: this.$route.query.mid || "",
            taskList: [],
            tabNum: 1,
            finishlist: [],//所有学生列表
            finish: null,//完成学生
            unfinish: null,//未完成
            asksList: [],//错误率数据
            knows: [],
            flagBoon: false,//截止时间
            city: 1111,
            endDate: null,
            students: null,
            loading: false,
            urge: false,
            information1: '你的作业完成了吗？不可以对自己降低要求哟！因为你能做到更好！客户端点此m.tbkt.cn 下载安装。咨询电话：12556185',
            informationObj: {},
            tbkt_Token: localStorage.getItem("Tbkt-Token"),
            city_id: localStorage.getItem('city_id'),
            platform_id: localStorage.getItem('platform_id'),
            cur_play: null,//优化后当前需要播放的列表
            cur_sub: 0,//优化后当前需要播放的列表下标
            is_active: this.$route.query.is_active || 0,//gsd寒假活动加
            isSend: true,//防止连点
            hd_layer: false,//活动弹窗
            type: 1,//  type 1 催促未做完 2 催促个性化学习 3 催促错题订正
            is_edit: 0,
            sms_id: 0,
            audio:'',
            copyVal:''
        }
    },
    created () {
        this.informationObj = {
            1: [
                `（${this.getSmsdate(this.begin_date)}）语文的${this.task_name}作业以下孩子未完成，请尽快督促孩子完成。`,
                '',//接口获取
            ]
        }
        this.loading = true;
        this.getlist();
        let that = this;
        window.playfinished = function () {
            that.finishlist.forEach((item, inx) => {
                item.stopAudio = false;
                item.openAudio = false;
            });
            if (that.cur_sub) {
                if (that.cur_sub < that.cur_play.text_new.length) {
                    that.play(that.cur_play);
                } else {
                    that.cur_sub = 0;
                }
            }
            // that.stopaudio();
            that.finishlist.splice(0, 1, that.finishlist[0])
        }
    },
    destroyed () {
        this.stopaudio();
        window.playfinished = null;
    },
    computed: {
        level () {
            return this.$store.state.winterlevel
        }
    },
    methods: {
        send_qun () {
            this.send_Type = 'qun'
            this.information1 = this.informationObj[this.type][0];
        },
        reportClick () {
            this.$router.push("/base/shareToParent/" + this.classId + "/" + this.taskId + "/1/2/51" + '?is_active=' + this.is_active);
        },
        send_msg () {
            this.send_Type = 'msg';
            this.information1 = this.informationObj[this.type][1];
        },
        back () {
            this.$router.go(-1)
        },
        cuicu () {
            this.send_Type = 'qun'
            if (this.is_active) {//活动催促
                if (this.unfinish == 0) {
                    layer.tips('所有学生都已完成');
                    return false;
                }
                this.information1 = this.is_active == 2 ? "家长您好！为了让孩子度过一个充实的寒假，我为孩子推荐了一份“寒假作业”，其中包含了知识复习和新课预习，帮助孩子巩固学习，更加从容的步入新学期。" : "家长您好！为了让孩子度过一个充实的暑假，我为孩子推荐了一份“暑假作业”，其中包含了知识复习和新课预习，帮助孩子巩固学习，更加从容的步入新学期。"
                this.hd_layer = true;
                return false;
            }
            if (Number(this.unfinish)) {
                this.$store.dispatch('urge_content', {
                    'sid': 51,
                    'task_type': this.task_name,
                    'begin_date': Number(this.begin_date),
                    'type': this.type
                }).then((res) => {
                    let _res = res.data.data;
                    this.sms_id = _res.sms_id;
                    this.informationObj[this.type][1] = _res.content;
                    this.information1 = this.informationObj[this.type][0];
                    this.is_edit = 0;
                    this.urge = !this.urge;
                })
                //写评语
                // this.information1 = this.is_active?'家长您好！为了让孩子度过一个充实的寒假，我为孩子推荐了一份“寒假作业”，其中包含了知识复习和新课预习，帮助孩子巩固学习，更加从容的步入新学期。':'你的作业完成了吗？不可以对自己降低要求哟！因为你能做到更好！';
            } else {
                layer.tips('所有学生都已完成')
            }
        },
        info1 () {
            var textVal = this.information1.length;
            if (this.send_Type == 'msg') {
                this.is_edit = 1;
            }
            if (this.information1.length >= 200) {
                layer.tips('已经超过200字了')
            }
        },
        cancel () {
            this.is_edit = 0;
            this.urge = false;
            this.hd_layer = false;
        },
        release2 () {//发送短信
            if (!this.isSend) {
                return false;
            }
            this.isSend = false;
            let this_ = this
            let stu_user_id = []
            this.finishlist.forEach(item => {
                if (item.status == 0) {
                    stu_user_id.push(item.user_id)
                }
            })
            this.$http.post(API_URL_TASK_API + '/public/task/urge', {
                message_id: this_.taskId,
                unit_class_id: this_.classId,
                sid: this_.sid,
                stu_user_id: stu_user_id.join(','),
                type: this.type,
                content: this_.information1,
                task_type: this.task_name,
                begin_date: Number(this.begin_date),
                is_edit: this.is_edit,
                sms_id: this.sms_id,
                place_id: 25,//配置平台发送短信配置参数
            }).then(res => {
                this.isSend = true;
                if (res.data.response == 'ok') {
                    this_.urge = false;
                    layer.tips("发送成功！");
                } else {
                    layer.tips("发送失败！");
                }
            })
            this.isSend = true;
        },
        release () {
            let that=this
            // if(!this.isSend){
            //     return false;
            // }
            // this.isSend = false;
            this.information1 = this.information1.replace(/(^\s*)|(\s*$)/g, "");
            this.information1 = this.information1.replace(/,/g, '，');
            if (this.information1.length > 200) {
                layer.tips('已经超过200字了');
                return false
            } else if (this.information1 == 0) {
                layer.tips('内容为空');
                return false
            }

            this.$http.post(API_URL_TASK_API + '/public/task/tea/share/in', {
                message_id: this.taskId,
                unit_class_id: this.classId,
                content: this.information1,
                type: 0
            }).then(res => {
                // this.isSend = true;
                if (res.data.response == 'ok') {
                    this.cancel();
                    let id = res.data.data.id;
                    let content = res.data.data.content;
                    let url = VUE_URL_HD + `/#/share/examine_task?sid=5&type=0&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    let title = `同步课堂`;
                    if (this.city_id == "411600") {
                        title = "随堂练";
                    }
                    let place = "教师检查作业催促发送到群里";
                    let active_id = 0;
                    if (this.is_active) {//活动
                        if (this.is_active == 2) {
                            active_id = 2;
                            place = "寒假活动教师检查作业催促发送到群里";
                            content = "寒假作业完成情况，请家长注意查看！";
                            url = VUE_URL_HD + `/#/winter2020/tea/sharePreview?subject_id=51&unit_class_id=${this.classId}&message_id=${this.mid ? this.mid : this.taskId}&level=${this.level}&tbkt_token=${this.tbkt_Token}`;
                        } else {
                            active_id = 4;
                            place = "暑假活动教师检查作业催促发送到群里";
                            content = "暑假作业完成情况，请家长注意查看！";
                            url = VUE_URL_HD + `/#/summer2020/taskShare?sid=51&unit_class_id=${this.classId}&message_id=${this.taskId}&level=${this.level}&tbkt_token=${this.tbkt_Token}`;
                        }
                    }
                    if(this.inApp){
                        this.appFunction("ys_share", `${title},${content},${url},${this.sid},${this.classId},0,${active_id},${place}`);
                    }else{
                        let coptText=`${title},${content},链接：${url}`
                        this.copyVal=coptText;
                        layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                            layer.close(index)
                            that.copyText(that.copyVal)
                        }, '分享链接复制成功')
                    }
                    
                }
            })
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        play (i) {
            if (i.text_new) {
                if (!this.cur_play) {
                    this.cur_play = i;
                }
                if (!i.stopAudio && !i.openAudio) {
                    i.openAudio = true;
                    i.stopAudio = true;
                    console.log('播放',this.cur_sub)
                    this.playaudio(i.text_new[this.cur_sub].record_url);
                    this.cur_sub++;
                } else if (i.openAudio) {
                    i.openAudio = false;
                    console.log('暂停',this.cur_sub-1)
                    this.pauseaudio(i.text_new[this.cur_sub-1].record_url);
                } else if (i.stopAudio && !i.openAudio) {
                    i.openAudio = true;
                    console.log('继续')
                    this.goonaudio(i.text_new[this.cur_sub-1].record_url);
                }
            } else {
                console.log('bbbb')
                if (!i.stopAudio && !i.openAudio) {
                    i.openAudio = true;
                    i.stopAudio = true;
                    this.playaudio(i.record_url);
                } else if (i.openAudio) {
                    i.openAudio = false;
                    this.pauseaudio(i.text_new[this.cur_sub].record_url);
                } else if (i.stopAudio && !i.openAudio) {
                    i.openAudio = true;
                    this.goonaudio(i.text_new[this.cur_sub].record_url);
                }
            }
            this.finishlist.splice(0, 1, this.finishlist[0]);
        },
        playaudio(audio){
            console.log(audio)
            this.audio=audio
            this.$nextTick(()=>{
                this.$refs.mp3.play();
            })
        },
        pauseaudio(audio){
            console.log(audio)
            this.audio=audio
            this.$nextTick(()=>{
                this.$refs.mp3.pause();
            })
        },
        goonaudio(audio){
            console.log(audio)
            this.audio=audio
            this.$nextTick(()=>{
                this.$refs.mp3.play();
            })
        },
        audioEnded(){
            setTimeout(() => {
                this.audio=''
            }, 300);  
        },
        preview (type) {//作业预览
            this.$router.push("/chinese/inspect/preview/word/" + this.taskId + "?taskType=1")
        },
        getlist () {
            let that = this;
            this.$http.post(API_URL_TASK_API + '/chinese/check/preview/task/detail', {
                "message_id": that.taskId,
                "unit_class_id": that.classId
            }).then(res => {
                let res1 = res.data;
                if (res1.response == 'ok') {
                    this.loading = true;
                    let data = res.data.data;
                    this.finishlist = data.students;
                    this.finishlist.forEach(item => {
                        item.openFlag = false;
                        item.openAudio = false;
                        item.stopAudio = false;
                        if (!item.result) {
                            item.result_text = '';
                        } else if (item.result === 'A') {
                            item.result_text = '优秀';
                        } else if (item.result === 'B') {
                            item.result_text = '良好';
                        } else if (item.result === 'C') {
                            item.result_text = '较好';
                        } else if (item.result === 'D') {
                            item.result_text = '一般';
                        }
                        if (item.text_new) {
                            item.text_new.forEach(it => {
                                it.openFlag = false;
                                it.openAudio = false;
                                it.stopAudio = false;
                            })
                        }
                    });
                    this.finish = data.finish_num;
                    this.unfinish = data.unfinished_num;
                    this.endDate = data.end_date;
                    //localStorage.setItem('unfinish', this.unfinish);

                    if (res1.data.is_end == 1) {
                        this.flagBoon = true;
                    } else {
                        this.flagBoon = false;
                    }
                }
            })
        },
        open (i, index) {
            this.cur_play = null;
            this.cur_sub = 0;
            this.finishlist.forEach((item, inx) => {
                item.stopAudio = false;
                item.openAudio = false;
                if (inx != index) {
                    item.openFlag = false;
                }
            });
            this.stopaudio();
            i.openFlag = !i.openFlag;
            this.finishlist.splice(index, 1, i)
        },
        reward () {
            this.$router.push("/tea/testreward/51/" + this.taskId + "/" + this.classId);
        },
        HDshare () {
            if (this.is_active == 2) { //2020寒假活动
                this.$router.push(`/activity/2020winter/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.mid ? this.mid : this.taskId}&sid=${this.sid}`);//gsd寒假活动加
            } else {
                this.$router.push(`/activity/2021summer/tea/sharePreview?unit_class_id=${this.classId}&message_id=${this.taskId}&sid=${this.sid}`);//gsd寒假活动加
            }
        }
    },
    filters: {
        trans: function (num) {
            return Math.floor(num / 60) + "\'" + (num % 60) + "\""
        },
    },
    components: {
        headers,
        loadingS
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.content {
    position: relative;
}

.title_container {
    width: 93.4%;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 0.4rem;
}

.lay_title {
    color: #000000;
    text-align: center;
    padding: 0.25rem 0;
    float: left;
    font-size: 0.7rem;
    border-bottom: none;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    box-sizing: border-box;
}

.title_on {
    background-color: #f0f0f0;
}

.title_tip {
    color: red;
    font-size: 0.6rem;
}

.lay_title1 {
    width: 30%;
}

.lay_title2 {
    width: 70%;
}

.content {
    width: 100vw;
    background: #f5f9ff;
    overflow-x: hidden;
    min-height: 100%;
}

.head {
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    div {
        width: 100%;
        height: 96px / $ppr;
        position: relative;
        .title {
            width: 100%;
            height: 96px / $ppr;
            text-align: center;
            line-height: 96px / $ppr;
            color: #fff;
            font-size: 34px / $ppr;
        }
        .back {
            width: 18px / $ppr;
            height: 36px / $ppr;
            background: url(../img/choose_back.png) no-repeat;
            background-size: 100%;
            position: absolute;
            top: 30px / $ppr;
            left: 24px / $ppr;
        }
        .preview {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 24px / $ppr;
            font-size: 28px / $ppr;
            z-index: 10;
            color: #fff;
        }
    }
}

.time_box {
    width: 100%;
    height: 96px / $ppr;
    margin-top: 96px / $ppr;
    background: #5e89ef;
    .jzTime {
        padding-left: 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        color: #fff;
        font-size: 30px / $ppr;
        float: left;
    }
    .endTime {
        float: right;
        font-size: 30px / $ppr;
        color: #dde7fd;
        margin-right: 24px / $ppr;
        line-height: 96px / $ppr;
    }
}

.tabs_tit-top {
    margin-top: 100px / $ppr;
    // text-align:center;
}
.notab {
    width: 100%;
    height: 96px / $ppr;
    font-weight: bold;
    line-height: 96px / $ppr;
    // text-align: left;
    font-size: 30px / $ppr;
    margin-bottom: 24px / $ppr;
    // padding-left: 24px/$ppr;
    background-color: #fff;
    position: relative;
    z-index: 2;
    text-align: center;
}

.check {
    border-bottom: 4px solid #5e89ef;
    color: #5e89ef;
}

.nocheck {
    color: #333;
}

.noresources {
    width: 100%;
    height: 300px / $ppr;
    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

.left {
    width: 100%;
    height: auto;
    .left_box {
        width: 100%;
        height: 239px / $ppr;
        background: #fff;
        padding-top: 23px / $ppr;
        .box_bg1 {
            width: 672px / $ppr;
            height: 238px / $ppr;
            background: url(./img/icon_bg1.png) no-repeat;
            background-size: 100%;
            margin: 0 auto;
            div {
                float: left;
                width: 330px / $ppr;
                height: 238px / $ppr;
                p {
                    width: 100%;
                }
                p:nth-child(1) {
                    height: 44px / $ppr;
                    line-height: 44px / $ppr;
                    text-align: center;
                    margin-top: 44px / $ppr;
                    color: #ff6600;
                    font-size: 48px / $ppr;
                    font-weight: bold;
                }
                p:nth-child(2) {
                    height: 23px / $ppr;
                    line-height: 23px / $ppr;
                    text-align: center;
                    margin-top: 15px / $ppr;
                    color: #999;
                    font-size: 24px / $ppr;
                }
                p:nth-child(3) {
                    text-align: center;
                    margin-top: 34px / $ppr;
                    color: #5e89ef;
                    font-size: 24px / $ppr;
                }
            }
            div:nth-child(1) {
                margin-right: 12px / $ppr;
            }
        }
    }
}

.list {
    width: 100%;
    height: auto;
    background: #fff;
    margin-top: 25px / $ppr;
    .list_box {
        width: 100%;
        border-bottom: 1px / $ppr solid #e2e5ec;
        .list_title {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            //font-weight:600;
            p:nth-child(1) {
                float: left;
                line-height: 96px / $ppr;
                font-size: 36px / $ppr;
                color: #333;
            }
            p:nth-child(2) {
                float: right;
                line-height: 96px / $ppr;
                font-size: 30px / $ppr;
                color: #5e89ef;
            }
        }
    }
    .lists {
        width: 100%;
        height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e2e5ec;
        div {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #333;
            }
            .name {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
            }
            .score {
                width: 120px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 84px / $ppr;
            }
            .upTime {
                width: 260px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
            }
        }
    }
    .lists1 {
        .lists_box {
            width: 100%;
            border-bottom: 1px / $ppr solid #e2e5ec;
        }
        .lists1_result {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #999;
                font-size: 30px / $ppr;
            }
            p:nth-child(1) {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
                position: relative;
            }
            p:nth-child(2) {
                width: 120px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 60px / $ppr;
                i {
                    color: #ff8042;
                }
            }
            p:nth-child(3) {
                width: 290px / $ppr;
                line-height: 96px / $ppr;
                span {
                    float: right;
                    width: 14px / $ppr;
                    height: 26px / $ppr;
                    margin-top: 34px / $ppr;
                    margin-left: 32px / $ppr;
                    background: url(img/icon_next.png) no-repeat;
                    background-size: 100%;
                }
                .open {
                    width: 28px / $ppr;
                    height: 28px / $ppr;
                    margin-top: 33px / $ppr;
                    margin-left: 16px / $ppr;
                    background: url(img/icon_jia.png) no-repeat;
                    background-size: 100% 100%;
                }
                .colse {
                    width: 28px / $ppr;
                    height: 28px / $ppr;
                    margin-top: 33px / $ppr;
                    margin-left: 16px / $ppr;
                    background: url(img/icon_jian.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
            .no {
                //width: 260px/$ppr;
                text-align: center;
            }
        }
        .lists1_detail {
            padding: 40px / $ppr 0;
            background-color: #fff;
            border-top: 1px / $ppr solid #e2e5ec;
            ul {
                @include displayFlex();
                padding: 0 20px / $ppr;
                li {
                    @include flex();
                    text-align: center;
                    border-right: 1px / $ppr solid #e2e5ec;
                    &:last-child {
                        border: 0;
                    }
                    p {
                        position: relative;
                        font-size: 26px / $ppr;
                        color: #999;
                    }
                    .detail_tit {
                        font-size: 30px / $ppr;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 10px / $ppr;
                    }
                }
                .playicon {
                    display: inline-block;
                    width: 24px / $ppr;
                    height: 24px / $ppr;
                    position: relative;
                    top: 4px / $ppr;
                    margin-right: 10px / $ppr;
                    background: url(img/play_audio.png) no-repeat;
                    background-size: 100% 100%;
                }
                .result {
                    margin-right: 16px / $ppr;
                    color: #ff8042;
                }
                .stopicon {
                    display: inline-block;
                    width: 24px / $ppr;
                    height: 24px / $ppr;
                    position: relative;
                    top: 4px / $ppr;
                    margin-right: 10px / $ppr;
                    background: url(img/stop_audio.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
    .lists_box:last-child {
        border: 0;
    }
}

.tig-bu {
    position: absolute;
    top: 30px / $ppr;
    width: 40px / $ppr;
    height: 36px / $ppr;
    padding: 1px 0;
    font-size: 24px / $ppr;
    color: #fff;
    background-color: #66cc22;
    margin-left: 12px / $ppr;
    line-height: normal;
    text-align: center;
    border-radius: 2px;
}

.layui-m-layerchild {
    text-align: center;
}

.textar {
    margin: auto 0;
    width: 86%;
    min-height: 200px / $ppr;
    margin: 30px / $ppr 0;
    margin-top: 0;
    background: #f0f0f0;
    border: none;
    padding: 20px / $ppr;
    border-bottom-left-radius: 10px / $ppr;
    border-bottom-right-radius: 10px / $ppr;
    font-size: 30px / $ppr;
}

.layui-m-layerbtn {
    border-top: 1px / $ppr solid #f0f0f0 !important;
    span {
        width: 50%;
        background: #fff;
    }
    span:nth-child(1) {
        border-right: 1px / $ppr solid #f0f0f0;
    }
    span:nth-child(2) {
        color: #5e89ef;
        border-right: 1px / $ppr solid #f0f0f0;
    }
}

.bottom_btn1 {
    .bottom_btn-div {
        width: 50%;
    }
}
.bottom_btn2 {
    .bottom_btn-div {
        width: 100%;
    }
}

.bottom_btn {
    width: 100%;
    height: 98px / $ppr;
    margin-top: 25px / $ppr;
    .bottom_btn-box {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
    }
    .share {
        background: #5e89ef;
    }
    .reward {
        background: #ff6600;
    }
    .reward,
    .share {
        color: #fff;
        p {
            text-align: center;
            margin: 0 auto;
            line-height: 98px / $ppr;
            // padding-left:50px/$ppr;
            position: relative;
        }
        img {
            display: inline-block;
            position: relative;
            width: 40px / $ppr;
            top: 8px / $ppr;
            margin-right: 10px / $ppr;
        }
    }
}
</style>
